<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @add="add"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @del="del"
                @imp='imp'
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="ProDCViewInfo"
                :filter_thousandth="['qty']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
                :authority="!btn.edit"
                @lct="editInfo"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
        >
            <el-table-column type="selection"></el-table-column>
            &lt;!&ndash;<el-table-column show-overflow-tooltip prop="num" :label="$t('getapi[589]')"></el-table-column>&ndash;&gt;
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[3437]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[2863]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[6348]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="dc_no" :label="$t('getapi[6377]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="qty" :label="$t('getapi[1628]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="dc_date" :label="$t('getapi[4053]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[6349]')"></el-table-column>
            <el-table-column show-overflow-tooltip fixed="right"  :label="$t('getapi[6048]')" width="60">
                <template slot-scope="scope" >
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope)"  type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
                </template>
            </el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProDCViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6376]')" queryData="ProDCViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="isShowEdit" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[6211]')}}</td>
                        <td><el-input v-model="dataDetail.item_code" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[2863]')}}</td>
                        <td>
                            <el-input
                                    v-model="dataDetail.part_code"
                                    type="text"
                                    size="mini"
                                    readonly
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectPart(scope)"></i>
                            </el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6348]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.part_version" :disabled="true"></el-input>
                        </td>
                        <td>{{$t('getapi[6377]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.dc_no"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[1628]')}}</td>
                        <td><el-input v-model="dataDetail.qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent :disabled="true"></el-input></td>
                        <td>{{$t('getapi[4053]')}}</td>
                        <td>
                            <el-date-picker v-model="dataDetail.dc_date" type="date" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6349]')}}</td>
                        <td><el-input v-model="dataDetail.remark"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="save" :loading="loading" :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true :postUrl="'/Inv/ReceieveIn/DcPartPopupDataList'" @callback="getPart" ref="part"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'2_prodc',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_prodc'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [], //勾选合集
                dataDetail: {},
                isShowEdit: false,
                btn:{
                    edit: false
                },
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProDCViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6376]"),this.$t("getapi[6588]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 275, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 275, 1) == 2) {
                    if (that.$limits.authority('plv3', 275,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 275,1) == 1) {
                        that.btn.edit = true
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 275, 1) == 2) {
                        that.btn.edit = true
                        //删除级
                        if(that.selectData.length > 0 ){
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,del');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                        }
                    }
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_prodc',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProDCViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Inv/ReceieveIn/GetProDcView', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Inv/ReceieveIn/GetProDcViewToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProDCViewInfo",
                    fromname: that.$t('getapi[6376]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.authority()
            },
            del(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let arr = []
                        for(let i=0;i<that.selectData.length;i++){
                            arr = [...arr,that.selectData[i]]
                        }
                        let parm = {
                            list: arr,
                            LangType:that.$processdata.getLang()
                        }
                        that.$http.urlpost('/Inv/ReceieveIn/DelProDc', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            editInfo(row){
                let that = this
                /*let parm = {
                    Id: row.row.exclusively_id
                }
                that.$http.urlpost('/Pur/RFQB/GetSchRFQPartInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowEdit = true
                        that.dataDetail = res.DataContent.Head
                    }
                });*/
                that.dataDetail.num = row.row.num
                that.dataDetail.item_code = row.row.item_code
                that.dataDetail.part_code = row.row.part_code
                that.dataDetail.part_version = row.row.part_version
                that.dataDetail.dc_no = row.row.dc_no
                that.dataDetail.qty = row.row.qty
                that.dataDetail.dc_date = row.row.dc_date
                that.dataDetail.remark = row.row.remark
                that.isShowEdit = true
            },
            // 新增
            add() {
                let that = this;
                that.isShowEdit = true;
                that.dataDetail = {
                    num:'',
                    item_code:'',
                    part_code:'',
                    part_version:'',
                    dc_no:'',
                    qty:'',
                    dc_date:'',
                    remark:''
                };
            },
            save(){
                let that = this
                let parm ={
                  Head: that.dataDetail,
                  LangType:that.$processdata.getLang()
                } 
                that.$http.urlpost('/Inv/ReceieveIn/ProDcSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowEdit = false
                        that.getView()
                    }
                });
            },
            selectPart(row) {
                let that = this;
                that.$refs.part.clearInput(true);
            },
            getPart(val) {
                let that = this;
                console.log(val)
                that.dataDetail.item_code = val.item_code;
                that.dataDetail.part_code = val.part_code;
                that.dataDetail.part_version = val.part_version
                that.dataDetail.qty = 1
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 5px!important;
    }
</style>
